import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="consultation-notes"
export default class extends Controller {
  
  static targets = ["tab"]
  
  focus(e) {
    const input = e.currentTarget
    const name = input.name
    const tab = name.match(/\[([^\]]+)\]$/)[1] // Tab is the part of the name between the last square brackets
    if (tab) this.tabTarget.value = tab
  }

}
